import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import "./styles/dropdown-enhancements.css";
import Header from "./components/Header/Header";
import Sidebar from "./components/Sidebar/Sidebar";
import Dashboard from "./components/Dashboard/Dashboard";
import Settings from "./components/Settings/Settings";
import Managements from "./components/Sidebar/Managements/Managements";
import UserDetails from "./components/UserDetails/UserDetails";
import VendorDetails from "./components/VendorDetails/VendorDetails";
import StaffManagements from "./components/StaffManagements/StaffManagements";
import StaffDetails from "./components/StaffDetails/StaffDetails";
import Orders from "./components/Orders/Orders";
import VendorApprovals from "./components/VendorApprovals/VendorApprovals";
import WebPageImages from "./components/WebPageImages/WebPageImages";
import Login from "./components/Login/Login";
import useUserStore from "./store/useUserStore";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

function AppContent() {
  const { isAuthenticated } = useUserStore();
  const { isLoading, authChecked } = useAuth();

  // Protected Route Component
  const ProtectedRoute = ({ children }) => {
    if (isLoading || !authChecked) {
      return (
        <div className="loading-container">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        </div>
      );
    }
    return isAuthenticated ? children : <Navigate to="/login" replace />;
  };

  // Public Route Component (redirects to dashboard if already authenticated)
  const PublicRoute = ({ children }) => {
    if (isLoading || !authChecked) {
      return (
        <div className="loading-container">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        </div>
      );
    }
    return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
  };

  return (
    <div className="app">
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        
        {/* Protected Routes */}
        <Route path="/" element={<ProtectedRoute><Navigate to="/dashboard" replace /></ProtectedRoute>} />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <div className="app">
              <Header />
              <div className="main-container">
                <Sidebar />
                <main className="content">
                  <Dashboard />
                </main>
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/orders" element={
          <ProtectedRoute>
            <div className="app">
              <Header />
              <div className="main-container">
                <Sidebar />
                <main className="content">
                  <Orders />
                </main>
              </div>
            </div>
          </ProtectedRoute>
        } />

        <Route path="/settings" element={
          <ProtectedRoute>
            <div className="app">
              <Header />
              <div className="main-container">
                <Sidebar />
                <main className="content">
                  <Settings />
                </main>
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/managements" element={
          <ProtectedRoute>
            <div className="app">
              <Header />
              <div className="main-container">
                <Sidebar />
                <main className="content">
                  <Managements />
                </main>
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/user-details/:userId" element={
          <ProtectedRoute>
            <div className="app">
              <Header />
              <div className="main-container">
                <Sidebar />
                <main className="content">
                  <UserDetails />
                </main>
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/vendor-details/:id" element={
          <ProtectedRoute>
            <div className="app">
              <Header />
              <div className="main-container">
                <Sidebar />
                <main className="content">
                  <VendorDetails />
                </main>
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/staff-managements" element={
          <ProtectedRoute>
            <div className="app">
              <Header />
              <div className="main-container">
                <Sidebar />
                <main className="content">
                  <StaffManagements />
                </main>
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/staff-details/:id" element={
          <ProtectedRoute>
            <div className="app">
              <Header />
              <div className="main-container">
                <Sidebar />
                <main className="content">
                  <StaffDetails />
                </main>
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/vendor-approvals" element={
          <ProtectedRoute>
            <div className="app">
              <Header />
              <div className="main-container">
                <Sidebar />
                <main className="content">
                  <VendorApprovals />
                </main>
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/webpage-images" element={
          <ProtectedRoute>
            <div className="app">
              <Header />
              <div className="main-container">
                <Sidebar />
                <main className="content">
                  <WebPageImages />
                </main>
              </div>
            </div>
          </ProtectedRoute>
        } />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
